export default __webpack_public_path__ + "static/media/joystickMain.b1c2541a.svg";